import React from 'react';
import type { LayoutProps as BaseLayoutProps } from 'antd';

import { Header } from './styled.tsx';

export const BaseHeaderLayout: React.FC<BaseLayoutProps> = ({ className, ...props }) => (
    <Header className={className} {...props} />
);
